module.exports = __webpack_public_path__ + "static/img/first1.84ce7c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/selection/pc/selection/first1.png
// module id = IfP5
// module chunks = 25